<template>
  <span class="def-price">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'DefPrice',
};
</script>

<style lang="scss" scoped>
.def-price {
  font-size: 16px;
  font-weight: 600;
  line-height: 125%;
}
</style>
